<template>
  <form>
    <v-layout row wrap justify-space-between pa-4>
      <v-flex xs12 sm6 md4 pt-3 pr-5>
        <auto-select
          v-model="deliveryOption"
          v-validate="'required'"
          label="Delivery Option"
          :items="deliveryOptions"
        ></auto-select>
      </v-flex>
      <v-flex xs12 sm6 md4 pt-3 pr-5>
        <auto-select
          v-model="orderType"
          v-validate="'required'"
          label="Order Type"
          :items="orderTypes"
        ></auto-select>
      </v-flex>
      <v-flex xs12 sm6 md4 pt-3 pr-5>
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="reqDeliveryDate"
          persistent
          lazy
          width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="reqDeliveryDateFormatted"
            label="Req. Delivery Date"
            append-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            class="mt-3"
            locale="en-GB"
            :reactive="false"
            v-model="reqDeliveryDate"
            scrollable
            first-day-of-week="1"
            :min="minDate"
          >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
            <v-btn
              flat
              color="primary"
              @click="$refs.dialog.save(reqDeliveryDate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs12 sm6 md4 pt-5 pr-5>
        <v-text-field
          v-validate="customersOrderNoRules"
          v-model="customersOrderNo"
          label="Your Order Number"
          type="text"
          counter="20"
          :rules="rules"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row justify-space-between pr-3 pl-3 pb-4>
      <v-btn class="mr-0" outline color="grey" dark @click="$emit('back')">
        <v-icon small class="pr-2">chevron_left</v-icon>
        Back
      </v-btn>
      <v-btn color="primary mx-0" @click="onClickContinue">
        Continue
        <v-icon small class="pl-2">chevron_right</v-icon>
      </v-btn>
    </v-layout>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import AutoSelect from "@/components/AutoSelect.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    AutoSelect
  },
  data() {
    return {
      modal: false,
      rules: [v => v.length <= 20 || "Max 20 characters"],
      customersOrderNoRules: {
        required: true,
        max: 20
      }
    };
  },
  computed: {
    ...mapGetters("customer", {
      deliveryOptions: "getDeliveryOptions",
      orderTypes: "getOrderTypes"
    }),
    orderType: {
      get() {
        return this.$store.state.basket.orderType;
      },
      set(value) {
        this.$store.dispatch("basket/setOrderType", value);
      }
    },
    deliveryOption: {
      get() {
        return this.$store.state.basket.deliveryOption;
      },
      set(value) {
        this.$store.dispatch("basket/setDeliveryOption", value);
      }
    },
    customersOrderNo: {
      get() {
        return this.$store.state.basket.customersOrderNo;
      },
      set(value) {
        this.$store.dispatch("basket/setCustomersOrderNo", value);
      }
    },
    reqDeliveryDate: {
      get() {
        return this.$store.state.basket.reqDeliveryDate;
      },
      set(value) {
        this.$store.dispatch("basket/setReqDeliveryDate", value);
      }
    },
    reqDeliveryDateFormatted() {
      const date = this.reqDeliveryDate ? new Date(this.reqDeliveryDate) : null;
      return date ? date.toLocaleDateString("en-GB") : null;
    },
    minDate() {
      const today = new Date();
      const minDate = new Date();
      minDate.setDate(today.getDate() + 1);
      return minDate.toISOString().substr(0, 10);
    }
  },
  methods: {
    onClickContinue() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }
        this.$emit("continue");
      });
    }
  }
};
</script>
